// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconServer } from '@ni/nimble-components/dist/esm/icons/server';
import { wrap } from '../utilities/react-wrapper';

export { type IconServer };
export const NimbleIconServer = wrap(IconServer);